/* Evernorth — scroll reveal progressive enhancement */
(function(){
  var root = document.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  root.classList.add('js-reveal');
  function run(){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el,i){
      el.style.transitionDelay = (Math.min(i%4,3)*70) + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
